import React, { Suspense, lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Spin } from 'antd'
import MainLayout from '../layouts/MainLayout'

// Lazy load pages
const News = lazy(() => import('../pages/News'))
const Analysis = lazy(() => import('../pages/Analysis'))
const StockScreening = lazy(() => import('../pages/StockScreening'))
const Holdings = lazy(() => import('../pages/Holdings'))
const Watchlist = lazy(() => import('../pages/Watchlist'))
const StockDetail = lazy(() => import('../pages/StockDetail'))
const IndustryDetail = lazy(() => import('../pages/IndustryDetail'))
const Notifications = lazy(() => import('../pages/Notifications'))
const Profile = lazy(() => import('../pages/Profile'))
const SubscriptionPlans = lazy(() => import('../pages/SubscriptionPlans'))
const Login = lazy(() => import('../pages/Login'))
const Register = lazy(() => import('../pages/Register'))
const ResetPassword = lazy(() => import('../pages/ResetPassword'))
const Impersonation = lazy(() => import('../pages/Impersonation'))
const PricingTable = lazy(() => import('../pages/PricingTable'))
const ProductIntroduction = lazy(() => import('../pages/ProductIntroduction'))

const pageFallback = (
  <div
    style={{
      minHeight: 240,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Spin size="large" tip="页面加载中..." />
  </div>
)

const withPageSuspense = (node: React.ReactNode) => (
  <Suspense fallback={pageFallback}>{node}</Suspense>
)

const Router: React.FC = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={withPageSuspense(<Login />)} />
      <Route path="/register" element={withPageSuspense(<Register />)} />
      <Route path="/reset-password" element={withPageSuspense(<ResetPassword />)} />
      <Route path="/subscription-plans" element={withPageSuspense(<SubscriptionPlans />)} />
      <Route path="/impersonation" element={withPageSuspense(<Impersonation />)} />
      <Route path="/pricing" element={withPageSuspense(<PricingTable />)} />
      <Route path="/product-introduction" element={withPageSuspense(<ProductIntroduction />)} />

      {/* Protected routes */}
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Navigate to="/holdings" replace />} />
        <Route path="news" element={withPageSuspense(<News />)} />
        <Route path="analysis" element={withPageSuspense(<Analysis />)} />
        <Route path="stock-screening" element={withPageSuspense(<StockScreening />)} />
        <Route path="stock-screening/new" element={withPageSuspense(<StockScreening />)} />
        <Route path="stock-screening/runs/:runId" element={withPageSuspense(<StockScreening />)} />
        <Route path="holdings" element={withPageSuspense(<Holdings />)} />
        <Route path="watchlist" element={withPageSuspense(<Watchlist />)} />
        <Route path="reports" element={<Navigate to="/analysis" replace />} />
        <Route path="stocks/:tsCode" element={withPageSuspense(<StockDetail />)} />
        <Route path="industries/:industryCode" element={withPageSuspense(<IndustryDetail />)} />
        <Route path="notifications" element={withPageSuspense(<Notifications />)} />
        <Route path="profile" element={withPageSuspense(<Profile />)} />
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/holdings" replace />} />
    </Routes>
  )
}

export default Router
